import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d46234a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-page" }
const _hoisted_2 = { class: "ws_common_operation" }

import { ref, onMounted } from 'vue'
import {
  queryWarningContactList,
  addWarningContact,
  updateWarningContact,
  deleteWarningContact,
} from '@/api'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import OperationButtonList from '@/components/operation-button-list'
import i18n from '@/i18n'
import ContactForm from './components/contact-form.vue'
import { msgbox } from '@/utils'
import { PAGE_SIZES, CODE_ENUM } from '@/common'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const t = i18n.global.t

const buttonList = [
  {
    type: 'edit',
    text: t('W_TACTICS.btnEdit'),
  },
  {
    type: 'delete',
    text: t('W_TACTICS.btnDel'),
  },
]

onMounted(() => {
  fetchList()
})

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const tableData = ref([])

const tableLoading = ref(false)

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const fetchList = async () => {
  tableLoading.value = true

  const res: any = await queryWarningContactList({
    ...pageParams.value,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === 0) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

const contactConf = ref({
  visible: false,
  data: {},
})

const handleForm = (data = {}) => {
  contactConf.value = {
    visible: true,
    data,
  }
}

const toDelete = ({ reachUserId, name }: any) => {
  const tip = t('W_CONTACT.delTip', { name })
  msgbox({
    tip,
    thenFn: () => handleDelete({ reachUserId }),
  })
}

const handleDelete = async ({ reachUserId }: any) => {
  const res: any = await deleteWarningContact({
    reachUserIds: [reachUserId],
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg)
  }

  fetchList()
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleForm
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('W_CONTACT.btnNew')), 1)
        ]),
        _: 1
      })
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      class: "ws_common_table ws_mt20",
      stripe: "",
      data: tableData.value
    }, {
      empty: _withCtx(() => [
        _createVNode(_component_el_empty, {
          description: _ctx.$t('W_MSG.noData')
        }, null, 8, ["description"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          label: _ctx.$t('W_CONTACT.index'),
          width: 80
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: _ctx.$t('W_CONTACT.colName')
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "phone",
          label: _ctx.$t('W_CONTACT.colPhone')
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "mail",
          label: _ctx.$t('W_CONTACT.colMail')
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "operation",
          label: _ctx.$t('W_CONTACT.colOp'),
          width: "280"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_unref(OperationButtonList), {
              buttonList: buttonList,
              scope: scope.row,
              onOnEdit: handleForm,
              onOnDelete: toDelete
            }, null, 8, ["scope"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, tableLoading.value]
    ]),
    _createVNode(_component_el_pagination, {
      class: "ws_mt50",
      "current-page": pageParams.value.curPage,
      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((pageParams.value.curPage) = $event)),
      "page-size": pageParams.value.pageSize,
      "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageParams.value.pageSize) = $event)),
      "page-sizes": _unref(PAGE_SIZES),
      layout: "->, total, sizes, prev, pager, next, jumper ",
      total: total.value,
      onSizeChange: handleSizeChange,
      onCurrentChange: handleCurrentChange
    }, null, 8, ["current-page", "page-size", "page-sizes", "total"]),
    _createVNode(ContactForm, {
      visible: contactConf.value.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((contactConf.value.visible) = $event)),
      data: contactConf.value.data,
      onSuccess: fetchList
    }, null, 8, ["visible", "data"])
  ]))
}
}

})